import type { CalculateFrequencyRequest, CalculateFrequencyResponse } from '@libs/common-types';
import { logger } from '@libs/core';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export type CalculateFrequencyParams = {
    locale: string;
    id: string;
    asFreq57?: boolean;
} & CalculateFrequencyRequest;

export async function calculateFrequency({
    locale,
    id,
    numberOfPets,
    totalCupsPerDay,
    asFreq57,
}: CalculateFrequencyParams): Promise<CalculateFrequencyResponse> {
    const url = CWEA_ENDPOINTS.product.calculateFrequency(locale, id, asFreq57);
    logger.info(`[CALCULATE FREQUENCY]: ${url}`);

    const result = await cweaClient.post<CalculateFrequencyResponse, CalculateFrequencyRequest>(url, {
        body: {
            numberOfPets,
            totalCupsPerDay,
        },
        useOldFetch: true,
    });

    if (!result) {
        logger.error(`[CALCULATE FREQUENCY][Error]: ${url}`);
        throw new Error(`[CALCULATE FREQUENCY]: ${url} returned null`);
    }

    return result;
}
